import { initReactI18next } from "react-i18next"
import featureAccountEn from "@gogoro/feature-account/server/public/locales/en-US/feature-account.json"
import featureAccountErrorEn from "@gogoro/feature-account/server/public/locales/en-US/feature-account_error.json"
import featureAccountZh from "@gogoro/feature-account/server/public/locales/zh-TW/feature-account.json"
import featureAccountErrorZh from "@gogoro/feature-account/server/public/locales/zh-TW/feature-account_error.json"
import prospectEn from "@gogoro/prospect/server/locales/en-US/prospect.json"
import prospectZh from "@gogoro/prospect/server/locales/zh-TW/prospect.json"
import { DevTools, I18nextPlugin, Tolgee, withTolgee } from "@tolgee/i18next"
import * as authenticationEn from "assets/translation/authentication/en-US.json"
import * as authenticationZh from "assets/translation/authentication/zh-TW.json"
import * as glossaryEn from "assets/translation/glossary/en-US.json"
import * as glossaryZh from "assets/translation/glossary/zh-TW.json"
import * as labelEn from "assets/translation/label/en-US.json"
import * as labelZh from "assets/translation/label/zh-TW.json"
import * as salesEn from "assets/translation/sales/en-US.json"
import * as salesZh from "assets/translation/sales/zh-TW.json"
import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import ICU from "i18next-icu"
import { environment } from "modules/environments"
import { transformI18nNextFormatToICU } from "utils/translationUtils"

const language =
  window.location.host.split(".").includes("globe") || window.location.host.split(".").includes("ph")
    ? "en-US"
    : "zh-TW"

const tolgeeI18N = async () => {
  const transformedProspectZh = transformI18nNextFormatToICU(prospectZh)
  const transformedProspectEn = transformI18nNextFormatToICU(prospectEn)
  const transformedFeatureAccountEn = transformI18nNextFormatToICU(featureAccountEn)
  const transformedFeatureAccountZh = transformI18nNextFormatToICU(featureAccountZh)
  const transformedFeatureAccountErrorEn = transformI18nNextFormatToICU(featureAccountErrorEn)
  const transformedFeatureAccountErrorZh = transformI18nNextFormatToICU(featureAccountErrorZh)

  const tolgee = Tolgee()
    .use(DevTools())
    .use(I18nextPlugin())
    .init({
      defaultLanguage: "en-US",
      apiUrl: process.env.REACT_APP_TOLGEE_API_URL,
      apiKey: process.env.REACT_APP_TOLGEE_API_KEY,
      staticData: {
        "en-US:sales": salesEn,
        "zh-TW:sales": salesZh,
        "en-US:label": labelEn,
        "zh-TW:label": labelZh,
        "en-US:glossary": glossaryEn,
        "zh-TW:glossary": glossaryZh,
        "en-US:authentication": authenticationEn,
        "zh-TW:authentication": authenticationZh,
        "zh-TW:prospect": transformedProspectZh,
        "en-US:prospect": transformedProspectEn,
        "en-US:feature-account": transformedFeatureAccountEn,
        "zh-TW:feature-account": transformedFeatureAccountZh,
        "en-US:feature-account_error": transformedFeatureAccountErrorEn,
        "zh-TW:feature-account_error": transformedFeatureAccountErrorZh,
      },
    })

  await import("@tolgee/web/tools").then((module) => {
    tolgee.addPlugin(module.InContextTools())
  })

  return withTolgee(i18n, tolgee)
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(ICU)
    .init({
      supportedLngs: ["en-US", "zh-TW"],
      fallbackLng: "en-US",
      lng: language,
      interpolation: {
        escapeValue: false,
      },
      appendNamespaceToCIMode: environment !== "production",
    })
}

export default tolgeeI18N
